export class HeaderCta {
  constructor() {
    this.el = document.getElementById('js-header-cta')
    if (this.el === null) return
    // this.parent = this.el.parentNode
    this.page = document.getElementById('page')
    this.portal()
    // window.addEventListener('resize', this.portal.bind(this))
  }
  portal() {
    if (this.el === null || this.page === null) return
    const { innerWidth } = window
    if (innerWidth < 768) {
      this.page.appendChild(this.el)
    }
  }
}
